import React from 'react';
import './Headergaleri2.css'; // Importe le CSS
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'; // Import de l'icône de flèche


function Headergaleri2() {
  return (
    <div className="header-containerga12">
        <div className="boutton-containerga12">
                <div className='butga123'>
                  
             <button className="bouttonga123">GALERIE<ArrowForwardIcon className="12arrow-icon" />MARIAGES</button>
             <h1>MARIAGES</h1> 
            </div>
            </div>
    </div>
  );
}

export default Headergaleri2;

